import { render, staticRenderFns } from "./UsersComponent.vue?vue&type=template&id=c198278c&scoped=true"
import script from "./UsersComponent.vue?vue&type=script&lang=js"
export * from "./UsersComponent.vue?vue&type=script&lang=js"
import style0 from "./UsersComponent.vue?vue&type=style&index=0&id=c198278c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c198278c",
  null
  
)

export default component.exports